import { filter } from 'lodash';
import { productMap } from 'services/Products';
  import mdPlaceholder from 'assets/custom-video/Smart_Video_Invitation_Image.jpg';
import natPlaceholder from 'assets/custom-video/national-poster.png';

export const getEligibleBeneficiaries = (
  productType,
  videoEligibilities,
  activeBeneficiary
) => {
  let eligibleKeys = [];
  videoEligibilities.forEach((eligibility) => {
    if (eligibility && eligibility.productType === productMap[productType]) {
      if (eligibility.eligibleBeneficiaryKeys) {
        const filteredBenes = filter(
          eligibility.eligibleBeneficiaryKeys,
          (key) => key.firstName !== activeBeneficiary
        );
        eligibleKeys = filteredBenes;
      }
    }
  });
  return eligibleKeys;
};

export const placeholderImages = {
  maryland529: mdPlaceholder,
  national529: natPlaceholder
};
